import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '../common/permission-service.service';

@Directive({
  selector: '[eoAllPermissions]',
})
export class EoAllPermissionsDirective {
  @Input('eoAllPermissions') permissions!: string[];

  constructor(
    private tokenService: PermissionService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    const hasPermission = this.tokenService.hasPermission(
      this.permissions,
      'ALL'
    );

    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
